import { environment } from "../config/environment";
import { customFetch, customFetchM } from "./Auth";

export const queryAllDatasets = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/datasets`,
      {
        method: "GET",
        headers: { token: localStorage.token }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data.datasets;
    } else {
      console.error("Error querying datasets:", res.statusText);
      alert("Error querying datasets");
    }
  } catch (error) {
    console.error("Error querying datasets:", error);
  }
}

export const queryDataset = async (datasetId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/datasets/${datasetId}`,
      {
        method: "GET",
        headers: { token: localStorage.token }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying dataset:", res.statusText);
      alert("Error querying dataset");
    }
  } catch (error) {
    console.error("Error querying dataset:", error);
  }
}

export const importHuggingFaceDataset = async (datasetName) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/huggingface-import?huggingface_dataset=${datasetName}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      },
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      const errorData = await res.json().catch(() => ({}));
      const errorMessage = errorData.error || res.statusText || "Error importing dataset";
      
      // Create a proper error object
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error("Error importing dataset:", error);
  }
}

export const uploadDataset = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  console.log(file)
  try {
    const res = await customFetchM(`${environment.apiUrl}/fine-tuning/file-upload`, {
      method: "POST",
      body: formData,
      headers: {
        token: localStorage.token
      }
    });

    if (res.ok) {
      const data = await res.json();
      return data;
    } else {
      console.error("Error uploading dataset:", res.statusText);
      alert("Error uploading dataset");
    }
  } catch (error) {
    console.error("Error uploading dataset:", error);
  }
}


export const deleteDataset = async (datasetId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/datasets/${datasetId}`, {
      method: "DELETE",
      headers: {
        token: localStorage.token
      }
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error deleting dataset:", res.statusText);
      alert("Error deleting dataset");
    }
  } catch (error) {
    console.error("Error deleting dataset:", error);
  }
}

export const queryAllModels = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models`,
      {
        method: "GET",
        headers: { token: localStorage.token }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data.models;
    } else {
      console.error("Error querying models:", res.statusText);
      alert("Error querying models");
    }
  } catch (error) {
    console.error("Error querying models:", error);
  }
}

export const createNewModel = async (modelData) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      },
      body: JSON.stringify(modelData)
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error creating model:", res.statusText);
      alert("Error creating model");
    }
  } catch (error) {
    console.error("Error creating model:", error);
  }
}

export const queryModel = async (modelId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models/${modelId}`,
      {
        method: "GET",
        headers: { token: localStorage.token }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying model:", res.statusText);
      alert("Error querying model");
    }
  } catch (error) {
    console.error("Error querying model:", error);
  }
}

export const updateModelConfig = async (modelId, configData) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models/${modelId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      },
      body: JSON.stringify(configData)
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error updating model config:", res.statusText);
      alert("Error updating model config");
    }
  } catch (error) {
    console.error("Error updating model config:", error);
  }
}

export const updateHuggingfaceModelName = async (modelId, huggingfaceModelName) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models/${modelId}/update`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      },
      body: JSON.stringify({ huggingfaceModelName })
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error updating huggingface model name:", res.statusText);
      alert("Error updating huggingface model name");
    }
  } catch (error) {
    console.error("Error updating huggingface model name:", error);
  }
}

export const fineTuneModel = async (modelId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/fine-tune/${modelId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      }
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error fine-tuning model:", res.statusText);
      alert("Error fine-tuning model");
    }
  } catch (error) {
    console.error("Error fine-tuning model:", error);
  }
}

export const deployModel = async (modelId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models/${modelId}/deploy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      }
    });

    if (res.ok) {
      const data = await res.json();
      alert("Model deployed successfully");
      return data;
    } else {
      console.error("Error deploying model:", res.statusText);
      alert("Error deploying model");
    }
  } catch (error) {
    console.error("Error deploying model:", error);
  }
}

export const terminateModel = async (modelId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models/${modelId}/terminate`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error terminating model:", res.statusText);
      alert("Error terminating model");
    }
  } catch (error) {
    console.error("Error terminating model:", error);
  }
}

export const generateNewDataset = async ( payload ) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/datasets/generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      },
      body: JSON.stringify(payload)
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error generating dataset:", res.statusText);
      alert("Error generating dataset");
    }
  } catch (error) {
    console.error("Error generating dataset:", error);
  }
}

export const generateDataset = async (generationData) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/datasets/generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      },
      body: JSON.stringify(generationData)
    });

    if (!res.ok) {
      // Try to get error message from response
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || `Generation failed with status: ${res.status}`);
    }

    return await res.json();
  } catch (error) {
    console.error("Error in generateDataset:", error);
    throw error;
  }
};

export const compareModels = async (payload) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models/compare`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      },
      body: JSON.stringify(payload)
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error comparing models:", res.statusText);
      alert("Error comparing models");
    }
  } catch (error) {
    console.error("Error comparing models:", error);
  }
}

export const deleteMIModel = async (modelId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models/${modelId}`, {
      method: "DELETE",
      headers: {
        token: localStorage.token
      }
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error deleting model:", res.statusText);
      alert("Error deleting model");
    }
  } catch (error) {
    console.error("Error deleting model:", error);
  }
}

export const deploy3rdPartyModel = async (payload) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/fine-tuning/models/deploy-3rd-party`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token
      },
      body: JSON.stringify(payload)
    });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error deploying 3rd party model:", res.statusText);
      alert("Error deploying 3rd party model");
    }
  } catch (error) {
    console.error("Error deploying 3rd party model:", error);
  }
}